import { SelectComPesquisa } from "@/Components/SelectComPesquisa"
import { ContaViagemSituacoesLista } from "@/Models/Domain/Viagem/Financeiro/ContaViagem/ContaViagemSituacao";

interface IContaViagemSituacaoSelectProps extends React.ComponentProps<typeof SelectComPesquisa> {
}

export default function ContaViagemSituacaoSelect ({
    placeholder,
    onChange, 
    value,
    ...rest
}:IContaViagemSituacaoSelectProps) {
    return <SelectComPesquisa 
        {...rest}
        placeholder={placeholder ?? "Selecione"}
        allowClear
        loading={false}
        options={ContaViagemSituacoesLista}
        onChange={onChange}
        value={value}
    />
}